// Single AuthSession per app: legacy $api (axios) and api-client (fetch) share its refresh mutex.

import { saveReloginContext } from '@/utils/reloginContext';

import { AuthSession } from './AuthSession';
import { createLegacyRefreshFn } from './legacyRefresh';

let session: AuthSession | null = null;

export const bootstrapAuthSession = (authApiBase: string): AuthSession => {
  if (session) {
    return session;
  }
  session = new AuthSession({ refreshFn: createLegacyRefreshFn(authApiBase) });
  session.initialize();

  // Global redirect on session death so reactive paths don't leave the UI tokenless.
  session.onChange((state) => {
    if (state !== 'dead') {
      return;
    }
    if (window.location.pathname === '/login') {
      return;
    }
    saveReloginContext();
    window.location.href = '/login';
  });

  return session;
};

export const getAuthSession = (): AuthSession => {
  if (!session) {
    throw new Error('AuthSession not bootstrapped - call bootstrapAuthSession() first');
  }
  return session;
};
